<template>
  <div class="OnlineBiddingDetail">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">在线竞价</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ ProjectName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="right_content">
      <div class="title2" style="margin-top: 15px">项目信息</div>
      <div class="change_inform">
        <el-form :inline="true" :model="schemeData" class="form_table" ref="ruleForm1" :inline-message="true">
          <el-form-item label="采购编号" prop="SchemeCode">{{ schemeData.SchemeCode }} </el-form-item>
          <el-form-item label="商务联系人" prop="Executor"> {{ schemeData.Executor }} </el-form-item>
          <el-form-item label="报价开始时间" prop="EvaluationBeginTime"> {{ schemeData.EvaluationBeginTime }} </el-form-item>
          <el-form-item label="项目名称" prop="ProjectName"> {{ schemeData.ProjectName }} </el-form-item>
          <el-form-item label="联系方式" prop="Mobile" label-width="150px" ref="InvoiceType">{{ schemeData.Mobile }} </el-form-item>
          <el-form-item label="报价结束时间" prop="EvaluationEndTime"> {{ schemeData.EvaluationEndTime }}</el-form-item>
        </el-form>
      </div>
      <div class="title2" style="display: flex">
        报价明细
        <el-button type="text" class="btn" size="small" @click="fnDownload(FileId)">下载报价文件</el-button>
        <span class="title2_span">总报价金额(元)：{{ TotalTenderAmount }} </span>
      </div>
      <el-table :data="schemeProjectList" class="el_table" border>
        <el-table-column prop="Index" label="序号" width="50px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="SupplierInstrumentName" label="供货设备名称" width="200px"></el-table-column>
        <el-table-column prop="SupplierSpecification" label="供货设备规格型号" width="200px"></el-table-column>
        <el-table-column prop="file" label="技术参数">
          <template slot-scope="scope">
            <el-link @click="fnReadPdf(scope.row.fileId, scope.row.fileId1)" :underline="false" style="color: #0361b1"> 预览</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="Count" label="数量"> </el-table-column>
        <el-table-column label="我的报价">
          <template slot-scope="scope">
            {{ parseFloat(parseFloat(scope.row.Price) * parseFloat(scope.row.Count)).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="Trademark" label="品牌要求"></el-table-column>
        <el-table-column prop="DeliveryTime" label="货期要求"></el-table-column>
        <el-table-column prop="SettlementMethodName" label="结算方式"></el-table-column>
        <el-table-column prop="ReceivingCompanyCode" label="交货地址"></el-table-column>
        <el-table-column prop="WarrantyRequirement" label="保修要求"></el-table-column>
        <el-table-column prop="TraceabilityUnit" label="溯源机构"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      ProjectName: this.$route.query.ProjectName,
      SchemeId: this.$route.query.SchemeId,
      TotalTenderAmount: this.$route.query.TotalTenderAmount,
      schemeData: {},
      FileId: '',
      schemeProjectList: []
    }
  },

  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let config = {
        params: {
          SchemeId: this.SchemeId
        }
      }

      this.getRequest('Purchase/GetOnlineBiddingData', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.schemeData = res.data.scheme
            this.IsStart = this.schemeData.IsStart
            this.schemeProjectList = res.data.schemeProject
            this.FileId = res.data.supplierQuote.FileId
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    fnDownload(FileId) {
      var url = 'Common/DownLoadFile?fileId=' + FileId + '&token=' + '' + '&fileName=' + ''

      this.downloadfile(this.baseURL + url)
    },
    fnReadPdf(fileId, fileId1) {
      let routerData = this.$router.resolve({
        path: 'ReadPDF',
        query: {
          fileId: fileId,
          fileId1: fileId1
        }
      })
      window.open(routerData.href, '_blank')
    }
  }
}
</script>
<style scoped lang="scss">
.right_content {
  margin: 0 10px;
  height: 93%;
  background: #fff;
}

.title2 {
  font-size: 18px;
  border-bottom: 1px solid #95c7f0;
  padding-bottom: 7px;
  margin: 7px;
}

//重写el_tabs样式
.el_tabs {
  margin: 7px 7px 0;
}

.el_tabs ::v-deep .el-tabs__header {
  float: none;
  margin-right: 0;
  margin-bottom: 0;

  .el-tabs__nav-wrap::after {
    background-color: #95c7f0;
  }

  .el-tabs__item {
    padding: 0 40px;
    color: #054c81;
  }

  .el-tabs__item.is-active {
    color: #fff;
    background: #2db7f5;
  }

  .el-tabs__active-bar {
    display: none;
  }
}

//重写el-table样式
.el_table {
  width: 100%;
  margin: 0 auto;
  border: none;
}

.el_table ::v-deep .el-table__header {
  th {
    background: #f2f2f2;
    text-align: center;
    border-bottom: 2px solid #e4e4e4;
    color: #333;
  }
}

.el_table ::v-deep .el-table__body-wrapper {
  tr {
    background-color: #e6f6fb;
  }

  td {
    text-align: center;
    border-bottom: 1px solid #e4e4e4;
    border-right: none;
    background-color: #fff;
  }
}

.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}

.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;

  .btn_1 {
    background: #f60;
    border: 1px solid #f60;
    color: #fff;
    border-radius: 8px;
  }

  .btn_1:nth-of-type(1) {
    margin-right: 30px;
  }
}

.title2_span {
  margin-left: auto;
  color: #0660a2;
  font-weight: bold;
  font-size: 13px;
}
.btn {
  margin-left: 50px;
  color: #fff;
  border: 1px solid #6a96bc;
  border-radius: 5px;
  padding: 2px 18px;
  font-size: 15px;
  background: #2db7f5;
}
</style>